// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductsList_list__GXOzY","sectionTitle":"ProductsList_sectionTitle__DsXzM","sectionProducts":"ProductsList_sectionProducts__NIzLO"};